import React from "react";
import { useNavigate } from "react-router-dom";

// SIDENAV_REDESIGN_PLAN.md Part 2 — dual-service resolution. Shown when a Global SideNav row
// (My Account/Governance/Growth) resolves to BOTH myFpo and mybusiness as real, accessible
// destinations for the current account — never silently pick one, per this session's "never
// silently choose" principle. `item` is a useGlobalSideNav() { mode: "choose", label, options }
// result; render nothing when there's no item to prompt for.
export default function ServiceSelectPrompt({ item, onClose }) {
  const navigate = useNavigate();
  if (!item) return null;

  const handleSelect = (path) => {
    onClose();
    navigate(path);
  };

  return (
    <div
      className="modal d-block"
      style={{ background: "rgba(0,0,0,0.45)", position: "fixed", inset: 0, zIndex: 1060 }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="service-select-prompt-title"
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: 380 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content" style={{ borderRadius: 16, border: "none" }}>
          <div className="px-4 pt-4 pb-3 text-center">
            <h5 id="service-select-prompt-title" className="fw-bold mb-1" style={{ fontSize: 16 }}>
              Choose a service
            </h5>
            <p className="text-muted mb-3" style={{ fontSize: 13 }}>
              You have access to "{item.label}" in more than one service.
            </p>
            <div className="d-flex flex-column gap-2">
              {item.options.map((opt) => (
                <button
                  key={opt.serviceKey}
                  type="button"
                  className="btn btn-outline-success"
                  onClick={() => handleSelect(opt.path)}
                >
                  {opt.serviceLabel}
                </button>
              ))}
            </div>
            <button
              type="button"
              className="btn btn-link btn-sm mt-2 text-muted"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
